var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BFormSpinbutton',_vm._g({attrs:{"inline":"","aria-label":_vm.switchLabel,"disabled":_vm.disabled,"name":_vm.name,"min":_vm.min,"max":_vm.max},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }